// extracted by mini-css-extract-plugin
export var lg = "_3b-4";
export var md = "_3b-3";
export var sm = "_3b-2";
export var xs = "_3b-1";
export var xxs = "_3b-0";